import { render, staticRenderFns } from "./btnAddReportCard.vue?vue&type=template&id=79a81ee4"
import script from "./btnAddReportCard.vue?vue&type=script&lang=js"
export * from "./btnAddReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports